"use client";

import { alpha } from "@mui/material/styles";
import dynamic from "next/dynamic";

const toastOptions = {
  style: {
    backgroundColor: alpha("#ecf4ff", 0.9),
    padding: "12px 30px",
  },
};

// Dynamically import Toaster to prevent SSR issues
const ReactHotToaster = dynamic(
  () => import("react-hot-toast").then((mod) => mod.Toaster),
  { ssr: false }
);

const Toaster = () => <ReactHotToaster {...toastOptions} />;

export default Toaster;
